import React from "react";
import {
  Flex,
  Image,
  Link as ChakraLink,
  Text,
  VStack,
  Skeleton,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

import { RestaurantMenu } from "../features/customer/types/state";
import { useGlobalContext } from "../context/globalContext";

interface Props {
  menu: RestaurantMenu;
  link: string;
}

const MenuCard: React.FC<Props> = ({ menu, link }) => {
  const { isMobile } = useGlobalContext();

  return (
    <ChakraLink as={RouterLink} to={link} w="100%">
      <VStack align="flex-start" w="100%" spacing={1}>
        <Flex
          borderRadius="md"
          overflow="hidden"
          bg="gray.100"
          w="100%"
          h={isMobile ? "200px" : "240px"}
        >
          <Image
            src={menu.photoHref}
            fallbackSrc={menu.photoHref}
            alt="menu photo"
            objectFit="cover"
            w="100%"
          />
        </Flex>
        <Flex>
          <Text fontSize="1.1em" color="gray.600">
            {menu.name}
          </Text>
        </Flex>
      </VStack>
    </ChakraLink>
  );
};

export const MenuCardSkeleton: React.FC = () => {
  const { isMobile } = useGlobalContext();

  return (
    <VStack>
      <Skeleton borderRadius="md" w="100%" h={isMobile ? "200px" : "240px"} />
      <Skeleton w="100%" h="20px" />
    </VStack>
  );
};

export default MenuCard;
